import './index.scss'

import { Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import PageTabs from '@components/PageTabs'

export default function VolunteeringPage() {
  const { t } = useTranslation('volunteering');

  return (
    <div className='volunteering-page'>
      <PageTabs
        title={t('tabs.title')}
        tabs={[
          { label: t('tabs.teams'), path: '/volunteering' },
          { label: t('tabs.trainingModules'), path: '/volunteering/training' }
        ]} />

      <Outlet />
    </div>
  )
}
